import '@babel/polyfill'

import Vue from 'vue'
import Vuex from 'vuex'
//@ts-ignore
import globalStoreObject from '@/globalStoreObject.ts'
//@ts-ignore
import vueInstances from '@/vueInstances.ts'
//@ts-ignore
import helpers from '@/helpers.ts'
import VueClickOusideComponent from 'vue-click-outside-component'
import VueClickOusideElement from 'vue-click-outside-element'
//@ts-ignore
import personAfil from './components/ui/person-afil/personAfil.vue'
//@ts-ignore
import tooltip from './components/ui/tooltip/tooltip.vue'

Vue.use(Vuex)
Vue.use(VueClickOusideComponent)
Vue.use(VueClickOusideElement)

Vue.mixin({
    methods: {
        ...helpers,
        redirect(to) {
            window.location.href = to
        },
        redirectBlank(url) {
            window.open(window.location.origin + url)
        }
    },
    // TODO "watcher любого изменения"
    // watch: {
    //     $data: {
    //         handler(next) {
    //             Object.keys(next).forEach(e => {
    //                 console.log(e, next)
    //             })
    //         },
    //         deep: true
    //     }
    // }
    computed: {
        window() {
            return window
        },
        auth() { return window.auth }
    }
})

Vue.directive('router-link-fallback', {
    bind(el, _, vnode) {
        if(vnode?.context?.$route?.matched?.length) {
            const route = $(el).attr('href')
            $(el).click(evt => {
                evt.preventDefault()
                evt.stopPropagation()
                $('#screen-check-address').hide()
                $('#screen-check-passport').hide()
                $('.uk-modal').hide()
                vnode.context.$router.push(route)
                $(window).scrollTop(0)
            })
        }
    }
})

Vue.config.ignoredElements = ['ymaps']

Vue.directive('focus', {
    inserted(el) {
        el.focus()
    }
})

Vue.directive('if-i-last', {
    bind(el, binding) {
        el.addEventListener('click', (e) => {
            e.stopPropagation()
            const nodeList = Array.from(el.parentElement.children)
            nodeList.forEach((e, i) => {
                if(e === el && i === nodeList.length - 1) {
                    binding.value(true)
                } else {
                    binding.value(false)
                }
            })
        })
    },
    unbind(el) { el.onclick = null }
})

Vue.directive('if-i-visible', {
    bind(el, binding) {
        const observer = new IntersectionObserver((entries) => { binding.value.callback(entries) }, {
            root: binding.value.root,
            rootMargin: '0px',
            threshold: 1.0
        })
        observer.observe(el)
    }
})

window.onload = function () {
    for (const e of vueInstances) {
        const { el, components } = e
        if ($(el).length) {
            new Vue({
                el,
                components,
                store: new Vuex.Store(globalStoreObject)
            })
        }
    }
    Vue.component(personAfil.name, personAfil)
    Vue.component(tooltip.name, tooltip)
}
